import faker from 'faker';
import moment from 'moment';
import { dateFormat } from '@app/helpers/dateTimeFormats';

export const processo = [
  {
    text: 'Contrato',
    value: 'contrato',
  },
  {
    text: 'Medição',
    value: 'medicao',
  },
  {
    text: 'Documentação Acessória',
    value: 'docAcessoria',
  },
];

export const fornecedor = [
  {
    text: 'Ullrich',
    value: 'Ullrich',
  },
  {
    text: 'Rohan',
    value: 'Rohan',
  },
  {
    text: 'Brown',
    value: 'Brown',
  },
];

export const responsavel = [
  {
    text: 'Freida',
    value: 'Freida',
  },
  {
    text: 'Haley',
    value: 'Haley',
  },
];

export default Array(50)
  .fill(0)
  .map((_, index) => ({
    id: index,
    processo: processo[0].value,
    atividade: faker.lorem.words(5),
    contrato: faker.lorem.words(2),
    fornecedor: fornecedor[1].value,
    responsavel: responsavel[0].value,
    dataInicio: moment(faker.date.recent(10)).format(dateFormat),
    dataConclusao: moment(faker.date.future(2)).format(dateFormat),
  }));
